// extracted by mini-css-extract-plugin
export var borderRadius = "_ax-4";
export var large = "_ax-3";
export var logoContainer = "_ax-0";
export var nameLogo = "_ax-2";
export var small = "_ax-1";